import type React from "react"
import type { SyncStatus } from "../../../types/sync-progress"

interface CompletionMessageProps {
  syncStatus: SyncStatus
}

const CompletionMessage: React.FC<CompletionMessageProps> = ({ syncStatus }) => {
  if (syncStatus.status !== "completed") return null

  return (
    <div className="completion-message">
      <div className="success-icon">
        <img data-emoji="🎉" className="an1" alt="🎉" aria-label="🎉" draggable="false" src="https://fonts.gstatic.com/s/e/notoemoji/16.0/1f389/32.png" loading="lazy" />
        </div>
      <h2>Sync Setup Complete!</h2>
      <p>Please active the connector to start syncing data.</p>
    </div>
  )
}

export default CompletionMessage
